document.addEventListener('DOMContentLoaded', () => {
  const formData = {
    items: [],
    sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble', 'cart-drawer'],
  };

  const addFormData = (productId, variantId, qty = 1, properties = {}) => {
    formData.items.push({
      id: variantId,
      quantity: qty,
      properties: properties,
    });
  };


  const handleButtonClick = (event) => {
    event.preventDefault(); // Prevent the default form submission
    const target = event.target;
    const form = target.closest('form');
    if (target.getAttribute('aria-disabled') === 'true') return;

    // Disable the button and show the loading spinner
    target.setAttribute('aria-disabled', true);
    target.classList.add('loading');
    const loadingSpinner = target.querySelector('.loading__spinner');
    if (loadingSpinner) {
      loadingSpinner.classList.add('loading');
      loadingSpinner.classList.remove('hidden');
    }



        // Determine quantity
  const quantityInput = document.querySelector('input.quantity__input[name="quantity"]');
    const quantity = quantityInput ? quantityInput.value : 1;

    console.log('Captured quantity:', quantity);


    // Determine variant ID
    const variantElement = form.querySelector('input[name="id"]');
    let variantId = form.querySelector('select[name="id"], input[name="id"]');

    variantId = variantId ? variantId.value : form.dataset.variantId;
    const variantSKU = variantElement ? variantElement.dataset.sku : form.dataset.variantSku;

    if (!variantId) {
      console.error('Variant ID is missing');
      return;
    }

    // Initialize properties object
    const properties = {};

 // Check if the product has the 'Greetings Card' tag
const isGreetingCard = document.querySelector('.product-form__greeting-card') !== null;

// Check for greeting card message only if it is a greeting card
if (isGreetingCard) {
  // Check both possible IDs for the greeting card message
  let greetingCardMessage = document.querySelector('#greeting-card-message-product');
  
  // If the first ID is not found, check for the second one
  if (!greetingCardMessage) {
    greetingCardMessage = document.querySelector('#greeting-card-message-upsell');
  }


  if (greetingCardMessage && greetingCardMessage.value.trim() === '') {
    alert('Please enter a message for the greeting card.');
    target.removeAttribute('aria-disabled');
    target.classList.remove('loading');
    if (loadingSpinner) {
      loadingSpinner.classList.remove('loading');
      loadingSpinner.classList.add('hidden');
    }
    return;
  }

  properties['Greeting Card Message'] = greetingCardMessage.value;
}


    // Add main product to formData
    addFormData(form.dataset.productId, variantId, quantity, properties);
console.log(variantSKU);
    // Check for gift box option
    const giftCheckbox = document.querySelector('#giftbox');
    if (giftCheckbox && giftCheckbox.checked) {
      const giftProperties = { 'From SKU': variantSKU };
      addFormData(giftCheckbox.dataset.id, giftCheckbox.dataset.variantId, quantity, giftProperties);
    }

    // Submit form data to /cart/add.js
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          cartData: response,
        });
        (document.querySelector('cart-notification') || document.querySelector('cart-drawer')).renderMultipleContents(
          response,
        );
        formData.items = []; // Clear formData after successful add to cart
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        target.classList.remove('loading');
        target.removeAttribute('aria-disabled');
        const loadingSpinner = target.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('loading');
          loadingSpinner.classList.add('hidden');
        }
        if (target.closest('.drawer-container')) {
          document.querySelector('.drawer-container.open').classList.toggle('open');
        }
      });
  };

  const buttons = document.querySelectorAll('.product-form__submit');
  buttons.forEach((button) => {
    button.addEventListener('click', handleButtonClick);
  });
});